<common-activity-type-base
  [activity]="activity"
  [showStatus]="showStatus"
  [pendingReviewBanner]="pendingReviewBanner"
  *ngIf="inspection$ | async as inspection"
>
  <common-inspection-form
    *ngIf="activity.status == 'Open' || activity.status == 'InProgress'"
    [inspection]="inspection"
    (inspectionSubmitted)="inspectionSubmitted()"
    (inspectionChange)="inspectionChanged()"
  ></common-inspection-form>
  <common-inspection-report [inspection]="inspection" *ngIf="activity.status == 'Closed'"></common-inspection-report>
</common-activity-type-base>
